import axios from 'axios';
import {
  GET_HOME_CAMPAIGN_REQUEST,
  GET_HOME_CAMPAIGN_SUCCESS,
  GET_HOME_CAMPAIGN_FAILURE
} from 'Store/constants';

import errorMessage from './errorMessage';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getCampaignsData = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HOME_CAMPAIGN_REQUEST
    });

    let res;

    if (getState().auth.isAuthenticated) {
      res = await axios.get(`${API_GATEWAY}/campaigns/active/slider`);
    } else {
      res = await axios.get(`${API_GATEWAY}/campaigns/public/active/slider`);
    }
    dispatch({
      type: GET_HOME_CAMPAIGN_SUCCESS,
      payload: res.data.campaigns
    });

  } catch (e) {

    dispatch({
      type: GET_HOME_CAMPAIGN_FAILURE,
      payload: errorMessage
    });
  }
};

